export const COOKIE_BOUNCER = 'bouncer'
export const COOKIE_BOUNCER_AUID = '_bouncer_auid'
export const COOKIE_CONSENT = 'cookie_consent'
export const COOKIE_AGE_VERIFICATION = 'gw'
export const COOKIE_PASSCODE = 'passcode'
export const COOKIE_USERNAME = 'username'
export const COOKIE_USER_ID = 'user_id'
export const COOKIE_USER_LEVEL = 'user_lv'
export const COOKIE_PREF_CLI = 'pref_cli'
export const COOKIE_SIGNUP_TRACKER = 'signup_tracker'

export const COLOR_SCHEME = 'COLOR_SCHEME'
export const NOOP = 'NOOP'
